import { Box, DialogActions, FormControl, FormHelperText, Icon, IconButton, InputAdornment, Typography } from "@mui/material"
import MaterialInput from "../../components/MaterialInput"
import MaterialButton from "../../components/MaterialButton"
import MaterialSelect from "../../components/MasterSelect"
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import { all } from "axios";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import MaterialBox from "../../components/MaterialBox";
import { ChangeCircle, Percent } from "@mui/icons-material";
import Grid from "@mui/material/Grid2"

const Offerletter = ({ recruitmentdata, SalaryStructure, setOpen, handlerecruitmentchange, setrecruitmentdata, handleoffer, OfferleterUpdate }) => {

  const nav = useNavigate()
  const ViewOfferletter = () => {
    console.log(recruitmentdata, "data in offer popup");
    nav("/recruitment/Offer", {
      state: recruitmentdata?.
        offerid
    })
  }

  const checkAllFields = () => {
    let allowSubmit = false;
    if (recruitmentdata?.CtcStatus === "success" &&
      recruitmentdata?.salarystructureStatus === "success" &&
      recruitmentdata?.basicPercentageStatus === "success" &&
      recruitmentdata?.joiningdateStatus === "success") {
      allowSubmit = true;
    }
    else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (

    <>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption"
          >
            CTC PA <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            value={recruitmentdata.ctc}
            name="Ctc"
            onChange={(e) => handlerecruitmentchange("ctc", e.target.value)}
            error={recruitmentdata.CtcStatus === "error"}
            success={recruitmentdata.CtcStatus === "success"}
            variant="outlined"
            size="small"
          />
          {recruitmentdata.CtcStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Enter a valid Salary (4 to 15 digits)
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption"
          >
            Salary Structure <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialSelect
            name="salarystructure"
            value={recruitmentdata.salarystructure}
            onChange={(e) => handlerecruitmentchange("salarystructure", e)}
            options={SalaryStructure.map((value) => ({
              value: value?.id,
              label: value.structureName,
            }))}
            size="small"
            error={recruitmentdata.salarystructureStatus === "error"}
            success={recruitmentdata.salarystructureStatus === "success"}
            isClearable
          // isDisabled={!recruitmentdata.Ctc || recruitmentdata.Ctc.trim() === ""}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption"
          >
            Basic Percentage <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            value={recruitmentdata.basicPercentage}
            name="basicPercentage"
            onChange={(e) => handlerecruitmentchange("basicPercentage", e.target.value)}
            variant="outlined"
            size="small"
            error={recruitmentdata.basicPercentageStatus === "error"}
            success={recruitmentdata.basicPercentageStatus === "success"}
            icon={{
              component: (
                <Percent />
              ),
              direction: 'right',
              type: 'icon'
            }}
          />
          {recruitmentdata.basicPercentageStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Enter a valid Basic Percentage
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption"
          >
            Joining Date <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            type="date"
            name="joiningdate"
            value={recruitmentdata.joiningdate}
            onChange={(e) => handlerecruitmentchange("joiningdate", e.target.value)}
            error={recruitmentdata.joiningdateStatus === "error"}
            success={recruitmentdata.joiningdateStatus === "success"}
            variant="outlined"
            size="small"
            inputProps={{
              min: new Date().toISOString().split("T")[0], // Restrict past dates
            }}
          />
        </Grid>
      </Grid>
      <DialogActions sx={{ justifyContent: "center" }}>
        {/* <MaterialButton
                onClick={() => {setOpen(false)

                    setrecruitmentdata({})}
                }
                variant="gradient"
                color="dark"
              >
                Cancel
              </MaterialButton> */}
        <IconButton
          onClick={() => {
            setOpen(false)

            setrecruitmentdata({})
          }
          }
          sx={{ color: "red" }}
        >
          <CloseIcon />
        </IconButton>
        {recruitmentdata?.offerid ? (
          // <MaterialButton
          //   onClick={OfferleterUpdate}
          //   variant="gradient"
          //   color="dark"
          // >
          //   Update
          // </MaterialButton>
          <>
            <IconButton onClick={OfferleterUpdate} disabled={!checkAllFields()} sx={{ color: "green" }}>
              <ChangeCircle />
            </IconButton>
            <IconButton onClick={ViewOfferletter} sx={{ color: "green" }}>
              <VisibilityIcon />
            </IconButton>
          </>
        ) : (
          // <MaterialButton
          //   onClick={handleoffer}
          //   variant="gradient"
          //   color="dark"
          // //   disabled={!checkAllOfferFields()}
          // >
          //   Submit
          // </MaterialButton>

          <IconButton disabled={!checkAllFields()} onClick={handleoffer} sx={{ color: "blue" }}>
              <AddIcon />
          </IconButton>

        )}
      </DialogActions>
    </>

  )
}
export default Offerletter